import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { SUPPORTED_CURRENCIES } from "@/lib/currency";
import { useProfile, useUpdateProfile } from "@/hooks/useProfile";
import { toast } from "sonner";

interface CurrencySelectorProps {
  value?: string;
  onChange?: (currency: string) => void;
  saveToProfile?: boolean;
  className?: string;
}

export function CurrencySelector({
  value,
  onChange,
  saveToProfile = true,
  className,
}: CurrencySelectorProps) {
  const { data: profile } = useProfile();
  const updateProfile = useUpdateProfile();

  const currentValue = value || profile?.preferred_currency || "USD";

  const handleChange = async (newCurrency: string) => {
    if (onChange) {
      onChange(newCurrency);
    }

    if (saveToProfile && newCurrency !== profile?.preferred_currency) {
      try {
        await updateProfile.mutateAsync({ preferred_currency: newCurrency });
      } catch {
        toast.error("Failed to save currency preference");
      }
    }
  };

  return (
    <Select value={currentValue} onValueChange={handleChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder="Select currency" />
      </SelectTrigger>
      <SelectContent>
        {SUPPORTED_CURRENCIES.map((currency) => (
          <SelectItem key={currency.code} value={currency.code}>
            <span className="flex items-center gap-2">
              <span className="font-mono">{currency.code}</span>
              <span className="text-muted-foreground">{currency.symbol}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
